import { ApiService } from "./api.service";
export default class CalendarSettingsService extends ApiService {
  namespace = "calendar-settings";
  icon = "Calendar";
  name = "Updating Global Calendar Settings";
  favicon = "Calendar";
  window = 290;
  Width = 850;
  action = "action";
  constructor() {
    super("calendar-type");
  }
}
